export const QUERY_PARAMS_ID = 'id';
export const QUERY_PARAMS_STATUS = 'status';
